module.exports = __webpack_public_path__ + "static/pawprints_dashboard-88116474efe13e08bc188d3f4c114551.jpeg";